// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".min-bode-height[data-v-6042b574]{min-height:150px}.two-input[data-v-6042b574]{display:flex;justify-content:space-between}.two-input input[data-v-6042b574]{width:49%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
